export default {
  JSON_CONTENT_TYPE: 'application/json',
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE'
};


// WEBPACK FOOTER //
// ./src/constants/HttpConstants.ts